import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const ACCESS_KEY = "aya.access";
const REFRESH_KEY = "aya.refresh";

export const tokenStore = {
  save(data) {
    if (data?.access_token) localStorage.setItem(ACCESS_KEY, data.access_token);
    if (data?.refresh_token) localStorage.setItem(REFRESH_KEY, data.refresh_token);
  },
  clear() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
  refresh: () => localStorage.getItem(REFRESH_KEY),
};

export const stripTokens = ({ access_token, refresh_token, ...user }) => user;

export const refreshSession = async () => {
  const { data } = await api.post("/auth/refresh", { refresh_token: tokenStore.refresh() });
  tokenStore.save(data);
  return stripTokens(data);
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    if (error.response?.status === 401 && !original._retry && !url.startsWith("/auth/")) {
      original._retry = true;
      refreshPromise = refreshPromise || refreshSession().finally(() => { refreshPromise = null; });
      try {
        await refreshPromise;
        return api(original);
      } catch (e) {
        tokenStore.clear();
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e))).join(" ");
  }
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadFile(path, params, fallbackName) {
  const response = await api.get(path, { params, responseType: "blob" });
  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = match ? match[1] : fallbackName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
